<template>
  <div class="search-container">
    <div class="position-relative flex-center padding-top-20">
      <!-- <img class="bg-img position-absolute" style="width: 100%;height: 15vh;top: 0;"
          src="./static/icon_article_search.png"> -->
      <div class="search-box flex-center flex-col">
        <!-- <div class="font-24 font-weight color-333 margin-bottom-10"
          >在这里，我们为你提供帮助和支持</div
        > -->
        <div class="search color-bg-fff flex-center" :class="{ serachInput_active: isFocus }">
          <el-input
            v-model="searchKey"
            :placeholder="placeholder"
            class="margin-left-20"
            @keyup.enter.native="searchChange"
            @focus="onFocus"
            @blur="onBlur"
            accesskey="v"
          ></el-input>
          <div class="search-btn flex-center" @click="searchChange">
            <img style="width: 28px; height: 28px" src="./static/icon_home_search.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex-center margin-y-10">
      <span class="color-333 font-light font-16">热门关键词：</span>
      <div
        v-for="item in hotList"
        :key="item.id"
        @click="hotSearch(item.name)"
        class="font-14 padding-x-10 padding-y-2 margin-y-5 margin-right-10 font-light hotWord"
        >{{ item.name }}</div
      >
    </div>
    <div style="width: 100%; height: calc(100% - 180px); overflow-y: scroll">
      <div class="margin-bottom-10 flex flex-align-center" style="padding: 0 220px">
        <span class="color-333 font-weight font-18 margin-right-20">搜索结果</span>
        <yd-common-selector v-model="sortValue" :options="sortList" @input="sortChange" />
        <i
          v-if="sortType === 1"
          class="el-icon-caret-bottom font-30 pointer"
          @click="handleSort(2)"
        ></i>
        <i v-else class="el-icon-caret-top font-30 pointer" @click="handleSort(1)"></i>
      </div>
      <div
        v-if="articleList.length > 0"
        class="padding-bottom-10"
        style="overflow: auto; margin: 0 220px"
        v-loading="loading"
      >
        <div
          v-for="item in articleList"
          :key="item.id"
          @click="goDetail(item.id)"
          class="articleList padding-y-15 padding-x-20 margin-bottom-15 color-bg-fff"
        >
          <div class="flex-between">
            <div class="flex flex-align-center">
              <img :src="item.icon" style="width: 18px; height: 18px" />
              <span class="font-18 color-333 font-weight margin-left-15" v-html="item.title"></span>
            </div>
            <div class="flex-center">
              <div v-for="(it, index) in item.labels" :key="index">
                <div v-if="it && index < 3" class="label-item font-14 font-light">{{ it }}</div>
              </div>
            </div>
          </div>
          <div class="padding-bottom-10 content-border">
            <div class="font-14 color-666 font-normal rich-text" v-html="item.content"></div>
          </div>
          <div class="flex flex-align-center padding-top-10">
            <span class="color-999 font-14 margin-right-40">{{ item.time }}</span>
            <div class="flex flex-align-center">
              <img style="width: 16px; height: 16px" src="./static/icon_article_pageView.png" />
              <span class="color-999 font-14 margin-left-5">{{
                item.pageView > 999 ? '999+' : item.pageView
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-center flex-col" style="height: 48vh">
        <img style="width: 270px; height: 196px" src="./static/icon_article_ default.png" />
        <div class="color-666 font-light">没有找到对应的内容，您可以换一个关键词搜索试试~</div>
      </div>
    </div>
    <div class="text-right margin-top-20" style="width: 100%">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginations.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="paginations.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { articleSearch, labelType } from '@/api'
  import { isEmpty } from 'lodash-es'

  export default {
    data() {
      return {
        searchKey: '',
        paginations: {
          current: 1,
          size: 5
        },
        hotList: [],
        articleList: [],
        total: 0,
        loading: false,
        isFocus: false,
        placeholder: '请输入关键词进行搜索，如班次、订单、订票等',
        sortList: [
          { label: '按更新时间', value: 1 },
          { label: '按文案热度', value: 2 }
        ],
        sortValue: '1',
        sortType: 1,
        sortKey: 'searchUpdateTime:desc'
      }
    },
    mounted() {
      this.searchKey = this.$store.state.article.searchKey
      // this.initPage()
      this.getLabelType()
    },
    methods: {
      onFocus() {
        this.isFocus = true
      },
      onBlur() {
        this.isFocus = false
      },
      goDetail(id) {
        this.$router.push({
          path: `/articleDetail/ad/${id}/false`
        })
      },
      initPage() {
        const params = {
          ...this.paginations,
          key: this.searchKey,
          sortKey: this.sortKey
        }
        this.handleArticleSearch(params)
      },
      async handleArticleSearch(params) {
        if (!this.searchKey) {
          return
        }
        try {
          this.isFocus = false
          this.loading = true
          const { code, data } = await articleSearch(params)
          if (code === 0) {
            if (data.records && Array.isArray(data.records)) {
              data.records.forEach((it) => {
                if (it.label) {
                  it.labels = (it.label + '').split('、')
                }
                // 如果第二行是图片，把图片干掉，留白
                it.content = it.content.replaceAll('<img', '<span')
                it.content = it.content.replaceAll('#4292FF', '#22c655')
                it.title = it.title.replaceAll('#4292FF', '#22c655')
              })
            }
            this.articleList = data.records
            this.total = data.total
          }
        } catch (error) {
        } finally {
          this.loading = false
        }
      },
      async getLabelType() {
        const { code, data } = await labelType(3)
        if (code === 0 && !isEmpty(data)) {
          this.hotList = data
          if (isEmpty(this.hotList)) {
            return
          }
          this.placeholder = this.hotList[0].name
          this.searchChange()
        }
      },
      searchChange() {
        if (!this.searchKey) {
          if (this.placeholder !== '请输入关键词进行搜索，如班次、订单、订票等') {
            this.searchKey = this.placeholder
          } else {
            this.$message.warning('请输入关键词！')
          }
        }
        this.paginations = {
          current: 1,
          size: 10
        }
        this.$store.commit('UPDATE_ARTICLE_SEARCHKEY', this.searchKey)
        this.initPage()
      },
      hotSearch(name) {
        this.searchKey = name
        this.searchChange()
      },
      handleSizeChange(e) {
        this.paginations.size = e
        this.initPage()
      },
      handleCurrentChange(e) {
        this.paginations.current = e
        this.initPage()
      },
      // 搜索结果排序 1按时间 2按热度
      sortChange() {
        this.setSortKey()
      },
      // 排序方式 1倒序 2正序
      handleSort(type) {
        this.sortType = type
        this.setSortKey()
      },
      setSortKey() {
        if (this.sortValue === '1' && this.sortType === 1) {
          console.log(222);
          this.sortKey = 'searchUpdateTime:desc'
        }
        if (this.sortValue === '1' && this.sortType === 2) {
        console.log(333);
          this.sortKey = 'searchUpdateTime:asc'
        }
        if (this.sortValue === '2' && this.sortType === 1) {
        console.log(444);
          this.sortKey = 'pageView:desc'
        }
        if (this.sortValue === '2' && this.sortType === 2) {
        console.log(555);
          this.sortKey = 'pageView:asc'
        }
        this.initPage()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-container {
    background: linear-gradient(117deg, #b3e6cc 0%, #f8fdfc 49%, #e4f6e5 100%), #e6f8ef !important;
    height: calc(100vh - 96px);
    overflow: hidden;
  }
  .search-box {
    z-index: 10;
    width: 28vw;

    .search {
      transition: all 0.3s linear;
      width: 120%;
      height: 50px;
      border-radius: 42px;
      margin-left: 15px;
      box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.1);

      .search-btn {
        height: 100%;
        width: 30%;
        background-color: #22c655;
        border-radius: 0px 42px 42px 0px;
        box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.05);
      }
    }
  }

  .serachInput_active {
    transition: all 0.3s linear;
    transform: scale(1.05, 1.05);
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.5);
  }

  ::v-deep .el-input__inner {
    border: none !important;
    box-shadow: none !important;
    // padding: 0px; //前边边距去掉
  }

  .hotWord {
    border: 1px solid #22c655;
    border-radius: 6px;
    color: #22c655;
    cursor: pointer;
  }

  .articleList {
    cursor: pointer;
    border-radius: 4px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.06);
  }

  .rich-text {
    height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 行数 */
    -webkit-box-orient: vertical;
  }
  .label-item {
    padding: 2px 10px;
    background: #e2f7e5;
    border-radius: 4px;
    margin-right: 15px;
    color: #22c655;
  }
  .content-border {
    border-bottom: 1px solid #f1f1f1;
  }
  ::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #22c655;
    }
    .el-pagination {
      margin-right: 60px;
    }
  }
</style>
